import { useEffect, useState } from 'react';
import * as queryString from 'query-string';
import { initializeBraze } from '../../utils/braze';

const eventParameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

const utmCampaignNames = {
  POWER: 'power',
};

const eventNames = {
    EVENT_PROFILE_PAGE: 'utm_landing_event_page_webapp',
    POWER_PERKS_PAGE: 'utm_landing_power_perks_page_webapp',
};

export const useBraze = () => {
  const [brazeInstance, setBrazeInstance] = useState(null);

  const logCustomEvent = ({ name, parameters }) => {
    if (brazeInstance) {
      brazeInstance.logCustomEvent(name, parameters);
    }
  };

  const extractFilteredUtmParams = (search) => {
    const parsed = queryString.parse(search || '');
    return Object.fromEntries(
      Object.entries(parsed).filter(([key]) => eventParameters.includes(key)),
    );
  };

  const logPowerCampaignEvent = ({ search, eventName, memberId }) => {
    if (!brazeInstance || !memberId) {
      return;
    }

    const brazeUser = brazeInstance.getUser();
    const userId = brazeUser ? parseInt(brazeUser.getUserId(), 10) : null;
    if (userId !== memberId) {
      brazeInstance.changeUser(memberId);
    }

    const filteredParsed = extractFilteredUtmParams(search);
    const hasAnyUtmParam = Object.keys(filteredParsed).length > 0;
    const isMatchingCampaign = filteredParsed?.utm_campaign === utmCampaignNames.POWER;

    if (hasAnyUtmParam && isMatchingCampaign) {
      logCustomEvent({
        name: eventName,
        parameters: { ...filteredParsed, member_id: memberId },
      });
    }
  };

  useEffect(() => {
    let isMounted = true;

    (async () => {
      try {
        // This is a work around because the Braze npm package throws an ESM error during npm install
        const braze = await import('@braze/web-sdk');

        initializeBraze(braze);

        if (isMounted) {
            setBrazeInstance(braze);
        }
      } catch (error) {
        if (isMounted) {
            console.log('Braze error: ', error);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { brazeInstance, logCustomEvent, logPowerCampaignEvent, extractFilteredUtmParams, eventParameters, eventNames };
};
